import * as React from 'react';
import './spinner.css';

const Spinner = () =>
    <div className="spinner"/>

export default Spinner;
